import { render, staticRenderFns } from "./ResetUsername.vue?vue&type=template&id=46de8530"
import script from "./ResetUsername.vue?vue&type=script&lang=js"
export * from "./ResetUsername.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports